(function () {
  function getSkioRoot() {
    return document.querySelector('[data-skio-subscriptions]');
  }

  function getRechargeRoot() {
    return document.querySelector(
      '[id^="RechargeWidget_"], [data-recharge-subscription-widget], .recharge-subscription-widget, .rc-widget'
    );
  }

  function getLegacySubscriptionRadio() {
    return document.querySelector('input[name="purchaseOption"][value="subscription"]');
  }

  function getLegacyOneTimeRadio() {
    return document.querySelector('input[name="purchaseOption"][value="onetime"]');
  }

  function isSkioOneTimeSelected() {
    var skioRoot = getSkioRoot();

    if (!skioRoot) {
      return null;
    }

    var purchaseType = skioRoot.getAttribute('data-skio-purchase-type');

    if (purchaseType === 'onetime') {
      return true;
    }

    if (purchaseType === 'subscription') {
      return false;
    }

    var activeOneTimeCard = skioRoot.querySelector('[data-skio-purchase-option="onetime"].is-active');

    if (activeOneTimeCard) {
      return true;
    }

    var activeSubscriptionCard = skioRoot.querySelector('[data-skio-purchase-option="subscription"].is-active');

    if (activeSubscriptionCard) {
      return false;
    }

    return null;
  }

  function isRechargeOneTimeSelected() {
    var rechargeRoot = getRechargeRoot();

    if (!rechargeRoot) {
      return null;
    }

    var activeOneTimeLabel = rechargeRoot.querySelector(
      '.onetime-radio.rc-radio--active, .rc-radio--active.onetime-radio'
    );

    if (activeOneTimeLabel) {
      return true;
    }

    var activeSubscriptionLabel = rechargeRoot.querySelector(
      '.subscription-radio.rc-radio--active, .rc-radio--active.subscription-radio'
    );

    if (activeSubscriptionLabel) {
      return false;
    }

    var activeOneTimeInput = rechargeRoot.querySelector(
      '.rc-radio--active input[name="purchaseOption"][value="onetime"]'
    );

    if (activeOneTimeInput) {
      return true;
    }

    var activeSubscriptionInput = rechargeRoot.querySelector(
      '.rc-radio--active input[name="purchaseOption"][value="subscription"]'
    );

    if (activeSubscriptionInput) {
      return false;
    }

    var rechargeOneTimeRadio = rechargeRoot.querySelector('input[name="purchaseOption"][value="onetime"]');
    var rechargeSubscriptionRadio = rechargeRoot.querySelector('input[name="purchaseOption"][value="subscription"]');

    if (rechargeOneTimeRadio && rechargeOneTimeRadio.checked) {
      return true;
    }

    if (rechargeSubscriptionRadio && rechargeSubscriptionRadio.checked) {
      return false;
    }

    return null;
  }

  function isLegacyOneTimeSelected() {
    var subRadio = getLegacySubscriptionRadio();
    var oneTimeRadio = getLegacyOneTimeRadio();

    if (oneTimeRadio && oneTimeRadio.checked) {
      return true;
    }

    if (subRadio && subRadio.checked) {
      return false;
    }

    return null;
  }

  function shouldDimFreeGiftsBlock(block) {
    var shouldDimUnlessSubscription = block.getAttribute('data-dim-unless-subscription') === 'true';

    if (!shouldDimUnlessSubscription) {
      return false;
    }

    var skioOneTimeSelected = isSkioOneTimeSelected();

    if (skioOneTimeSelected !== null) {
      return skioOneTimeSelected;
    }

    var rechargeOneTimeSelected = isRechargeOneTimeSelected();

    if (rechargeOneTimeSelected !== null) {
      return rechargeOneTimeSelected;
    }

    var legacyOneTimeSelected = isLegacyOneTimeSelected();

    if (legacyOneTimeSelected !== null) {
      return legacyOneTimeSelected;
    }

    return false;
  }

  function updateFreeGiftsBlock(block) {
    if (!block) return;

    block.classList.toggle('free-gifts-container--dimmed', shouldDimFreeGiftsBlock(block));
  }

  function updateAllFreeGiftsBlocks() {
    var blocks = document.querySelectorAll('[data-free-gifts-block]');

    if (!blocks.length) return;

    blocks.forEach(function (block) {
      updateFreeGiftsBlock(block);
    });
  }

  function observeRechargeWidget() {
    var rechargeRoot = getRechargeRoot();

    if (!rechargeRoot || !window.MutationObserver) {
      return;
    }

    if (rechargeRoot.getAttribute('data-free-gifts-observed') === 'true') {
      return;
    }

    rechargeRoot.setAttribute('data-free-gifts-observed', 'true');

    var observer = new MutationObserver(function () {
      updateAllFreeGiftsBlocks();
    });

    observer.observe(rechargeRoot, {
      attributes: true,
      subtree: true,
      attributeFilter: ['class', 'checked', 'aria-pressed']
    });
  }

  function initFreeGiftsBlocks() {
    updateAllFreeGiftsBlocks();
    observeRechargeWidget();

    window.setTimeout(function () {
      updateAllFreeGiftsBlocks();
      observeRechargeWidget();
    }, 100);

    window.setTimeout(function () {
      updateAllFreeGiftsBlocks();
      observeRechargeWidget();
    }, 300);

    window.setTimeout(function () {
      updateAllFreeGiftsBlocks();
      observeRechargeWidget();
    }, 600);

    window.setTimeout(function () {
      updateAllFreeGiftsBlocks();
      observeRechargeWidget();
    }, 1200);

    window.setTimeout(function () {
      updateAllFreeGiftsBlocks();
      observeRechargeWidget();
    }, 2000);
  }

  document.addEventListener('DOMContentLoaded', initFreeGiftsBlocks);

  document.addEventListener('skio-subscriptions:price-change', function () {
    updateAllFreeGiftsBlocks();
  });

  document.addEventListener('click', function (event) {
    if (!event.target || !event.target.closest) return;

    var skioOption = event.target.closest('[data-skio-purchase-option]');
    var rechargeOption = event.target.closest(
      '.rc-radio, .subscription-radio, .onetime-radio, [id^="RechargeWidget_"] label'
    );

    if (!skioOption && !rechargeOption) return;

    window.setTimeout(function () {
      updateAllFreeGiftsBlocks();
      observeRechargeWidget();
    }, 0);

    window.setTimeout(function () {
      updateAllFreeGiftsBlocks();
      observeRechargeWidget();
    }, 100);
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Enter' && event.key !== ' ') return;
    if (!event.target || !event.target.closest) return;

    var skioOption = event.target.closest('[data-skio-purchase-option]');
    var rechargeOption = event.target.closest(
      '.rc-radio, .subscription-radio, .onetime-radio, [id^="RechargeWidget_"] label'
    );

    if (!skioOption && !rechargeOption) return;

    window.setTimeout(function () {
      updateAllFreeGiftsBlocks();
      observeRechargeWidget();
    }, 0);

    window.setTimeout(function () {
      updateAllFreeGiftsBlocks();
      observeRechargeWidget();
    }, 100);
  });

  document.addEventListener('change', function (event) {
    if (
      event.target &&
      (
        event.target.name === 'purchaseOption' ||
        event.target.hasAttribute('data-skio-plan-select')
      )
    ) {
      window.setTimeout(function () {
        updateAllFreeGiftsBlocks();
        observeRechargeWidget();
      }, 0);

      window.setTimeout(function () {
        updateAllFreeGiftsBlocks();
        observeRechargeWidget();
      }, 100);
    }
  });
})();